module.exports = __webpack_public_path__ + "img/pu_30.bedfad09.png";